import styled, { css } from 'styled-components';
import screenSizes, { media } from '../../theme/shared/breakpoints';
const getMediaQuery = (hiddenProps) => {
    if (!hiddenProps)
        throw new Error('<Hidden> component must have a prop declared!');
    const { at, lessThan, greaterThan, greaterThanOrEqual, between } = hiddenProps;
    if (at)
        return `${media.custom(0)} and (max-width: ${screenSizes[at] - 1}px)`;
    if (lessThan)
        return `@media (max-width: ${screenSizes[lessThan] - 1}px)`;
    if (greaterThan)
        return media[greaterThan];
    if (greaterThanOrEqual)
        return media[greaterThanOrEqual];
    if (between) {
        const [minWidth, maxWidth] = between;
        return `${media[minWidth]} and (max-width: ${screenSizes[maxWidth] - 1}px)`;
    }
    return '';
};
export const Hidden = styled.div `
  display: block;
  ${(props) => {
    const mediaQuery = getMediaQuery(props);
    if (mediaQuery) {
        return css `
        ${mediaQuery} {
          display: none;
        }
      `;
    }
    return null;
}}
`;
//# sourceMappingURL=Hidden.js.map